import React, { FC, useCallback, useMemo } from 'react';

import {
	BUTTON_TYPES,
	EvChipItem,
	EvChips,
	EvFlexColumn,
	EvPopup,
	FLEX_WRAP,
	TITLE_MODES
} from '@evinced-private/ui-common';

import { PLATFORM_APP_ID } from 'src/common/consts/dom-consts';

import { FILTERS_PANEL_OVERFLOW_MODAL_WIDTH } from './FiltersPanelOverflowModal.constants';
import { FILTERS_PANEL_OVERFLOW_MODAL_LABELS } from './FiltersPanelOverflowModal.labels';
import { IFiltersPanelOverflowModalProps } from './FiltersPanelOverflowModal.types';

import './FiltersPanelOverflowModal.scss';

export const FiltersPanelOverflowModal: FC<IFiltersPanelOverflowModalProps> = ({
	isOpen,
	chips,
	onClose,
	onRemoveChip
}) => {
	const chipItems: EvChipItem[] = useMemo(
		() =>
			chips.map((chip) => ({
				id: chip.filterId,
				label: `${chip.filterLabel}: ${chip.valueLabel}`,
				title: FILTERS_PANEL_OVERFLOW_MODAL_LABELS.REMOVE_FILTER(chip.filterLabel, chip.valueLabel)
			})),
		[chips]
	);

	const handleClose = useCallback(() => {
		onClose();
	}, [onClose]);

	const handleRemoveChip = useCallback(
		(filterId: string) => {
			onRemoveChip(filterId);
		},
		[onRemoveChip]
	);

	const buttons = [
		{
			title: FILTERS_PANEL_OVERFLOW_MODAL_LABELS.CLOSE,
			onClick: handleClose,
			type: BUTTON_TYPES.GHOST
		}
	];

	return (
		<EvPopup
			appElement={PLATFORM_APP_ID}
			isOpen={isOpen}
			isControlled
			isCentered
			isBgTransparent
			title={FILTERS_PANEL_OVERFLOW_MODAL_LABELS.TITLE}
			titleMode={TITLE_MODES.MAIN}
			popupWidth={FILTERS_PANEL_OVERFLOW_MODAL_WIDTH}
			buttons={buttons}
			onClose={handleClose}
		>
			<EvFlexColumn dataAutomationId="filters-panel-overflow-modal">
				<div className="filters-panel-overflow-modal__chips-list-container">
					<EvChips chips={chipItems} onClick={handleRemoveChip} wrap={FLEX_WRAP.WRAP} />
				</div>
			</EvFlexColumn>
		</EvPopup>
	);
};
